module.exports = __webpack_public_path__ + "static/media/inside.35d287ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene1/asset/inside.png
// module id = 1771
// module chunks = 0